import { CustomerFormTypes } from "models/formTypes";

type ColumnMapping = Omit<CustomerFormTypes.CustomerImport, "csvUpload">;

// Columns that together only appear in Fortnox's customer register export, so a match is safe to pre-fill.
// Country uses the code columns: country names are only recognised in Swedish, and an unrecognised one silently becomes Sweden.
const FortnoxSignatureColumns = ["customer_number", "organisation_number", "email_invoice", "invoice_address"];

const FortnoxColumnMapping: ColumnMapping = {
  customerNameColumn: "name",
  orgNrColumn: "organisation_number",
  emailAddressColumn: "email_invoice",
  phoneNumberColumn: "invoice_phone",
  billingStreetColumn: "invoice_address",
  billingStreet2Column: "invoice_address2",
  billingZipCodeColumn: "invoice_zip_code",
  billingCityColumn: "invoice_city",
  billingCountryCodeColumn: "invoice_country_code",
  deliveryStreetColumn: "delivery_address",
  deliveryStreet2Column: "delivery_address2",
  deliveryZipCodeColumn: "delivery_zip_code",
  deliveryCityColumn: "delivery_city",
  deliveryCountryCodeColumn: "delivery_country_code",
  vatNumberColumn: "vat_number",
  glnNumberColumn: "gln",
  customerStandardPaymentTermsColumn: "payment_terms",
  referencePersons: [{ nameColumn: "your_reference" }],
};

/** Returns the column mapping for a Fortnox customer export, or undefined when the headers are not Fortnox's. */
export const getFortnoxColumnMapping = (headers: string[]): ColumnMapping | undefined => {
  if (!FortnoxSignatureColumns.every((column) => headers.includes(column))) {
    return undefined;
  }

  const mapping = Object.fromEntries(
    Object.entries(FortnoxColumnMapping).filter(([, column]) => typeof column !== "string" || headers.includes(column))
  ) as ColumnMapping;

  if (!headers.includes("your_reference")) {
    delete mapping.referencePersons;
  }

  return mapping;
};
